module.exports = __webpack_public_path__ + "img/fi-rr-following.4047be3b.svg";